module.exports = __webpack_public_path__ + "static/media/land-hero-desktop.2704db92.jpg";